import React from "react"
import PropTypes from "prop-types"
import { useQuery } from "react-apollo"
import { useTracker } from "@modules/analytics"
import { ORGANIZATION_DETAILS } from "@modules/billing/queries"
import ToggleCheckbox from "@modules/ui/components/ToggleCheckbox"
import useToggleIncrementalBuilds from "../hooks/useToggleIncrementalBuilds"
import { isFreePlan } from "@modules/billing/shared/utils"
import { siteBuildsSettings as siteBuildsSettingsText } from "@modules/locales/default.js"
import { interpolateMessage } from "@modules/locales"

const propTypes = {
  siteId: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  incrementalBuildsEnabled: PropTypes.bool,
}

export default function IncrementalBuildsSettings({
  siteId,
  organizationId,
  incrementalBuildsEnabled,
}) {
  const { data, loading } = useQuery(ORGANIZATION_DETAILS, {
    variables: {
      id: organizationId,
    },
  })

  const [toggleIncrementalBuilds, { errorAlert }] = useToggleIncrementalBuilds(
    siteId
  )
  const { trackButtonClicked } = useTracker()

  if (loading) {
    return null
  }

  const billingData = data?.organizationDetails?.billing
  const disabled = isFreePlan(billingData?.status)

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-incremental-builds-checkbox"
        label={siteBuildsSettingsText.labels.enableIncrementalBuilds}
        checked={!!incrementalBuildsEnabled}
        onChange={() => {
          trackButtonClicked(`toggle incremental builds`, {
            uiSource: `Site Settings`,
          })

          toggleIncrementalBuilds()
        }}
        disabled={disabled}
        hint={
          disabled &&
          interpolateMessage(
            siteBuildsSettingsText.messages.incrementalBuildsDisabled,
            { freePlanName: billingData?.plan?.name || "" }
          )
        }
      />
      {errorAlert}
    </React.Fragment>
  )
}

IncrementalBuildsSettings.propTypes = propTypes
